export default __webpack_public_path__ + "assets/models/617107325889ae25bf037de29469cdf7.glb";